export default {
  onlyOneTip: 'Only one carousel component can be added per scene.',
  direction: {
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    label: 'Arrangement method',
  },
  displayNum: {
    label: 'Number of slots',
    title: 'Carousel group',
    desc: 'If there are 5 slots and the middle slot is considered as slot 1, then the slots from left to right would correspond to slots 4, 5, 1, 2, 3.',
  },
  carouselSetting: 'Settings',
  carouselType: {
    normal: 'Regular',
    pulseScale: 'Zoom in/out',
    rollScale: 'Scroll zoom',
    opacity: 'Fade in/out',
    opacityScale: 'Fade zoom',
  },
  playMode: {
    auto: 'Automatic',
    manual: 'Manual',
    title: 'Playback settings',
  },
  triggerMode: {
    click: 'Tap',
    drag: 'Drag',
    title: 'Interaction methods',
  },
  condition: {
    switchDone: {
      label: 'On carousel switch',
      tip: 'Trigger corresponding event when the carousel completes and stops.',
    },
    resourceSwitchDone: {
      label: 'To a specific resource',
      tip: 'Trigger corresponding event when a specific resource completes its carousel and stops.',
    },
    tagSwitchDone: {
      label: 'To a specific category',
      tip: 'To a specific category',
    },
  },
  component: {
    title: 'Carousel Component',
    libTitle: 'Carousel ',
    add: {
      tips: 'Each scene can only have one carousel component.',
    },
    stayTime: {
      label: 'Animation dwell time',
    },
    animationDuration: {
      label: 'Animation playback duration',
    },
    displaySize: 'Slot size',
    displaySpace: 'Slot spacing',
    style: {
      title: 'Carousel style selection',
      selectTips: 'Style selection',
    },
    group: {
      title: 'Resource group',
      add: 'Add Carousel Group',
    },
    pite: {
      setting: {
        title: 'Slot configuration',
      },
      switch: {
        tips: 'After disabling, the carousel cannot slide, and the event effects within it are lost.',
      },
    },
    method: {
      title: 'Interaction methods',
    },
    extraSetting: {
      title: 'Advanced settings',
    },
    mask: {
      title: 'Clip on overflow',
      scale: 'Crop',
      notScale: 'No crop',
    },
    resource: {
      title: 'Resource',
    },
    groupPreview: {
      title: {
        on: 'Cancel Preview',
        off: 'Preview Slot size',
      },
    },
    scale: {
      title: 'Slot Scale Ratio',
    },
  },
  tagManage: {
    title: 'Resource category',
    tabTitle: 'Resource category',
    select: {
      tips: 'Select category',
    },
    desc: 'Resource category is used to determine the timing of event success or failure.',
    add: {
      label: 'Add Categories',
    },
    delete: {
      tips: 'This category has been applied to carousel group resources. Are you sure you want to delete it?',
    },
    tag: {
      name: {
        label: 'Name',
      },
    },
  },
}
